var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('div',{class:_vm.classes,style:(_vm.styles)},[_vm._t("default")],2),_c('adm-button',{attrs:{"variant":"text","id":_vm.id},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.open ? _vm.labelLess : _vm.labelMore)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }